window.toggleURLParams = (key, value, singleValueParamKeys = []) => {
	const url = new URL(window.location.href);
	const rootUrl = url.origin + url.pathname;
	const params = new URLSearchParams(url.search);

	if (singleValueParamKeys.includes(key)) {
		if (value) {
			params.set(key, value);
		} else {
			params.delete(key);
		}
	} else {
		let currentValues = params.get(key) ? params.get(key).split(',') : [];

		if (currentValues.includes(value)) {
			// Remove value if it exists
			currentValues = currentValues.filter(item => item !== value);
		} else {
			// Add value if it doesn't exist
			currentValues.push(value);
		}

		if (currentValues.length > 0) {
			params.set(key, currentValues.join(','));
		} else {
			params.delete(key);
		}
	}

	const finalUrl = params.toString() ? `${rootUrl}?${params}` : rootUrl;
	window.history.pushState('', '', finalUrl);
}

// Function to get URL parameter values as an array
window.getURLParamValues = (key) => {
	const url = new URL(window.location.href);
	const params = new URLSearchParams(url.search);
	const paramValue = params.get(key);

	if (paramValue) {
		return paramValue.split(',').map(value => decodeURIComponent(value));
	}
	return [];
}

// Check if a URL parameter exists
window.hasURLParam = (key) => {
	const url = new URL(window.location.href);
	const params = new URLSearchParams(url.search);
	return params.has(key);
}

// remove parameter from URL
window.removeURLParam = (key) => {
	const url = new URL(window.location.href);
	const rootUrl = url.origin + url.pathname;
	const params = new URLSearchParams(url.search);

	if (params.has(key)) {
		params.delete(key);
		const finalUrl = params.toString() ? `${rootUrl}?${params}` : rootUrl;
		window.history.pushState('', '', finalUrl);
	}
}
